//#region src/cx.ts
function e(...e) {
	return e.filter(Boolean).join(" ");
}
//#endregion
export { e as t };

//# sourceMappingURL=cx-BjmrJCen.js.map